import api from "../api";

export default {
    keyFigures(params) {
        return api.get('/merchant/reports/keyFigures', params)
    }
}